import { CARD_SLOT, persistentCardTypes } from "@/features/cards/shared/card-routing/card-config";
import { INFO_CARD_TYPE } from "@/features/cards/shared/card-routing/card-types";
import { useStore } from "@/store/store";

import { AddDeviceGlobalState } from "./add-device-global-state";

/** Whether opening a map-entity card should be blocked by the currently open card. */
export function shouldBlockMapEntityCardOpen(cardType?: INFO_CARD_TYPE): boolean {
    // Zustand-hosted cards never register on FocusContext, so callers hand us `undefined` for them.
    // Fall back to the slot they actually live in, or they get usurped silently.
    const openCardType = cardType ?? useStore.getState().slots[CARD_SLOT.BOTTOM_RIGHT].cardType;
    if (!openCardType) {
        return false;
    }
    // Only block if the add device flow is not on its final step. The new Zustand-hosted card never
    // sets `isOnFinalStep`, so it always blocks and must be closed via its own discard-prompting path.
    if (openCardType === INFO_CARD_TYPE.ADD_DEVICE) {
        return !AddDeviceGlobalState.isOnFinalStep;
    }
    return persistentCardTypes.includes(openCardType);
}
